var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAzuresql = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0072C6",
    fillRule: "evenodd",
    d: "M8 8.372v23.256C8 34.042 13.373 36 20 36V8.372z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2687CF",
    fillRule: "evenodd",
    d: "M20 36c6.627 0 12-1.957 12-4.372V8.372H20z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32 8.372c0 2.414-5.373 4.371-12 4.371S8 10.786 8 8.372 13.373 4 20 4s12 1.958 12 4.372",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7FBA00",
    fillRule: "evenodd",
    d: "M29.546 8.12c0 1.594-4.274 2.884-9.546 2.884s-9.547-1.29-9.547-2.884S14.728 5.235 20 5.235s9.546 1.291 9.546 2.885",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8D432",
    fillRule: "evenodd",
    d: "M27.547 9.883c1.25-.488 2-1.098 2-1.762 0-1.594-4.274-2.886-9.547-2.886s-9.546 1.292-9.546 2.886c0 .663.75 1.274 2 1.762C14.2 9.2 16.927 8.762 20 8.762s5.8.44 7.547 1.12Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.189 24.515q0 1.084-.782 1.678-.782.596-2.16.596-1.172 0-1.96-.426v-1.7q.909.776 2.002.776.529 0 .816-.213a.67.67 0 0 0 .288-.563.8.8 0 0 0-.277-.6q-.276-.255-1.127-.66-1.733-.817-1.733-2.23 0-1.025.756-1.644.755-.62 2.006-.619 1.11 0 1.839.293v1.588a3 3 0 0 0-1.743-.531q-.49 0-.776.21a.66.66 0 0 0-.285.56q0 .36.23.592.23.23.943.571 1.06.505 1.513 1.025.452.522.45 1.297m8.148-1.721q0 1.345-.608 2.332a3.25 3.25 0 0 1-1.71 1.386l2.196 2.046h-2.218l-1.568-1.77a3.66 3.66 0 0 1-1.82-.536 3.35 3.35 0 0 1-1.252-1.368 4.2 4.2 0 0 1-.44-1.936q0-1.185.477-2.112a3.4 3.4 0 0 1 1.344-1.426q.866-.5 1.986-.5 1.044 0 1.872.484.826.483 1.283 1.376.458.893.458 2.024m-1.796.096q0-1.159-.502-1.83-.501-.673-1.373-.673-.886 0-1.42.674-.534.675-.534 1.796 0 1.115.523 1.782.521.666 1.389.666.882 0 1.4-.645t.517-1.77m7.558 3.765h-4.51v-7.617h1.705v6.226h2.804v1.392Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAzuresql);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/azuresql.00f95096.svg";